import React from 'react';
import styles from './Layout.module.scss';

const PreMatchesLayout = props => {
    return (
        <div className={styles.layout}>
            <div className={styles.layoutInnerWrapper}>
                <div className={styles.layoutContent}>{props.children}</div>
            </div>
        </div>
    );
};

export default PreMatchesLayout;
